import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
import Http from '../../../../Http';

class ClienteVentas extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'cliente/venta', saveUrl: 'cliente/save', backUrl: '/Catalogo/Cliente/' + this.props.match.params.id + '/Destinatarios' },
      new Form([
        Form.Field('select', 'cliente_id_giro_negocio', 'Giro del negocio', '', [Validators.required], 6),
        Form.Field('checkbox', 'cliente_importacion', 'Maneja mercancía de importación', false, [], 6),
        Form.Field('hidden', 'cliente_id_ejecutivo', '', '', [Validators.required], 0),
        Form.Field('text', 'ejecutivo', 'Clave', '', [Validators.required], 2),
        Form.Field('autocomplete', 'cliente_ejecutivo_nombre', 'Ejecutivo', '', [Validators.required], 5),
        Form.Field('date', 'cliente_fecha_neg', 'Fecha de negociación', '', [Validators.required], 5),
        Form.Field('text', 'cliente_observaciones', 'Observaciones', '', [Validators.required], 12),
        Form.Field('text', 'cliente_referencia', 'Referencia', '', [], 6),
        Form.Field('text', 'cliente_convenio', 'Respetar Convenio Global de Cliente Referencia Especificar Clave', '', [], 6),
      ], ['Guardar']), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds(this.props.match.params.id)
  }

  formData = async (form, ejecutivo = null) => {
    var Res = await Http.get(`cliente/form/ventas${(ejecutivo) ? `?e=${ejecutivo}` : ''}`);
    // console.log(Res.data);
    if (!Res.error) {
      var newForm = Form.FieldOptions(form, 'cliente_id_giro_negocio', Res.data.giros, 'id', 'giro_nombre');
      if (Res.data.ejecutivos) newForm = Form.FieldOptions(newForm, 'cliente_ejecutivo_nombre', Res.data.ejecutivos, 'id', 'ejecutivo_nombre');
      newForm = Form.ValueChange(newForm, { cliente_ejecutivo_nombre: this.ejecutivoChange });
      return newForm;
    }
  }

  ejecutivoChange = async (field) => {
    // this.setState({ FormData: await this.formData(this.state.FormData, field.Value) })
    if (field.Value) {
      let Res = await Http.get(`ejecutivo/one/${field.Value}`);
      if (!Res.error) {
        Res.data.cliente_id_ejecutivo = Res.data.id
        this.setState({ FormData: Form.Patch(this.state.FormData, Res.data, true) })
      }
    }
    else {
      this.setState({ FormData: await this.formData(this.state.FormData, field.ValueAt) })
    }
  }

  // onSubmit = async (i, vals) => {
  //   vals.id = this.props.match.params.id;
  //   var Res = await Http.post(`${this.config.saveUrl}`, vals);
  //   if (!Res.error) {
  //     this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true });
  //     this.props.onSave();
  //   }
  //   else
  //     this.setState({ loading: false, sbMsg: 'Error al guardar', sbOpen: true });

  // }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(ClienteVentas)
